import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Save16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M5.35229 2.45828C5.11238 2.45828 4.90422 2.53947 4.69731 2.74638L2.74638 4.69731C2.7308 4.71289 2.71452 4.72776 2.69759 4.74187C2.56521 4.85219 2.45828 5.07133 2.45828 5.35229V13.4347C2.45828 13.4431 2.46327 13.4721 2.49555 13.5044C2.52783 13.5367 2.55683 13.5417 2.56525 13.5417H13.4347C13.479 13.5417 13.5043 13.5344 13.5152 13.5302C13.5211 13.5279 13.5253 13.5253 13.5253 13.5253C13.5253 13.5253 13.5279 13.5211 13.5302 13.5152C13.5344 13.5043 13.5417 13.479 13.5417 13.4347V2.56525C13.5417 2.55683 13.5367 2.52783 13.5044 2.49555C13.4721 2.46327 13.4431 2.45828 13.4347 2.45828H5.35229ZM3.66615 1.71523C4.12813 1.25325 4.70034 1 5.35229 1H13.4347C14.2833 1 14.9999 1.71663 14.9999 2.56525V13.4347C14.9999 13.8512 14.8579 14.255 14.5565 14.5565C14.255 14.8579 13.8512 14.9999 13.4347 14.9999H2.56525C1.71663 14.9999 1 14.2833 1 13.4347V5.35229C1 4.75217 1.21955 4.0924 1.73592 3.64546L3.66615 1.71523Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M5.9097 1C6.31239 1 6.63884 1.32645 6.63884 1.72914V5.07358C6.63884 5.082 6.64383 5.111 6.67611 5.14328C6.70839 5.17556 6.7374 5.18056 6.74581 5.18056H10.9264C10.9348 5.18056 10.9638 5.17556 10.9961 5.14328C11.0283 5.111 11.0333 5.082 11.0333 5.07358V1.72914C11.0333 1.32645 11.3598 1 11.7625 1C12.1652 1 12.4916 1.32645 12.4916 1.72914V5.07358C12.4916 5.9222 11.775 6.63883 10.9264 6.63883H6.74581C5.89719 6.63883 5.18056 5.9222 5.18056 5.07358V1.72914C5.18056 1.32645 5.50701 1 5.9097 1Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M3.50803 9.25419C3.50803 8.40557 4.22466 7.68894 5.07328 7.68894H10.9261C11.862 7.68894 12.4913 8.43791 12.4913 9.25419V14.2709C12.4913 14.6736 12.1649 15 11.7622 15H4.23717C3.83447 15 3.50803 14.6736 3.50803 14.2709V9.25419ZM5.00358 9.18449C4.9713 9.21677 4.96631 9.24578 4.96631 9.25419V13.5417H11.033V9.25419C11.033 9.21335 11.018 9.18617 11.0048 9.17237C10.9985 9.1657 10.9911 9.16048 10.9818 9.1565C10.9729 9.1527 10.9557 9.14722 10.9261 9.14722H5.07328C5.06486 9.14722 5.03586 9.15221 5.00358 9.18449Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
